import { FunctionComponent } from 'react';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

type SubNavItemProps = {
  name: string;
  to: string;
};

export const SubNavItem: FunctionComponent<SubNavItemProps> = ({
  name,
  to,
}) => (
  <div className="ml-2 mt-2">
    <NavLink
      to={to}
      className={({ isActive }) =>
        cn('hover:underline', {
          'font-semibold': isActive,
        })
      }
    >
      <span className="mr-2 text-gray-600">{name}</span>
    </NavLink>
  </div>
);
